import PlaybooksAPI from 'dashboard/api/playbooks';

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isFetchingItem: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
  meta: {
    count: 0,
    currentPage: 1,
    totalPages: 1,
  },
};

const getters = {
  getPlaybooks: $state => $state.records,
  getPlaybookUIFlags: $state => $state.uiFlags,
  getPlaybookMeta: $state => $state.meta,
  getPlaybookById: $state => id =>
    $state.records.find(c => Number(c.id) === Number(id)),
};

const actions = {
  async fetchPlaybooks({ commit }, params = {}) {
    commit('setPlaybookUIFlag', { isFetching: true });
    try {
      const response = await PlaybooksAPI.get(params);
      commit('setPlaybooks', response.data.payload);
      commit('setPlaybookMeta', response.data.meta);
      return response.data;
    } finally {
      commit('setPlaybookUIFlag', { isFetching: false });
    }
  },

  async fetchPlaybook({ commit }, { id }) {
    commit('setPlaybookUIFlag', { isFetchingItem: true });
    try {
      const response = await PlaybooksAPI.show(id);
      commit('addOrUpdatePlaybook', response.data);
      return response.data;
    } finally {
      commit('setPlaybookUIFlag', { isFetchingItem: false });
    }
  },

  async createPlaybook({ commit }, playbookData) {
    commit('setPlaybookUIFlag', { isCreating: true });
    try {
      const response = await PlaybooksAPI.create(playbookData);
      commit('addOrUpdatePlaybook', response.data);
      return response.data;
    } finally {
      commit('setPlaybookUIFlag', { isCreating: false });
    }
  },

  async updatePlaybook({ commit }, { id, ...playbookData }) {
    commit('setPlaybookUIFlag', { isUpdating: true });
    try {
      const response = await PlaybooksAPI.update(id, playbookData);
      commit('addOrUpdatePlaybook', response.data);
      return response.data;
    } finally {
      commit('setPlaybookUIFlag', { isUpdating: false });
    }
  },

  async deletePlaybook({ commit }, id) {
    commit('setPlaybookUIFlag', { isDeleting: true });
    try {
      await PlaybooksAPI.delete(id);
      commit('removePlaybook', id);
    } finally {
      commit('setPlaybookUIFlag', { isDeleting: false });
    }
  },
};

const mutations = {
  setPlaybookUIFlag($state, flag) {
    $state.uiFlags = { ...$state.uiFlags, ...flag };
  },
  setPlaybooks($state, playbooks) {
    $state.records = playbooks || [];
  },
  setPlaybookMeta($state, meta = {}) {
    $state.meta = {
      count: meta.count || 0,
      currentPage: meta.current_page || 1,
      totalPages: meta.total_pages || 1,
    };
  },
  addOrUpdatePlaybook($state, playbook) {
    if (!playbook || !playbook.id) return;
    const index = $state.records.findIndex(c => c.id === playbook.id);
    if (index === -1) {
      $state.records = [playbook, ...$state.records];
    } else {
      const next = [...$state.records];
      next[index] = playbook;
      $state.records = next;
    }
  },
  removePlaybook($state, id) {
    $state.records = $state.records.filter(c => c.id !== id);
  },
};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations,
};
